import { Box, Stack, Typography, Paper, Alert } from '@mui/material';
import React from 'react';

import { PublicRoutes } from '@/config/routes';

interface AIFeatureBannerProps {
  showAccountPrompt?: boolean;
}

const AIFeatureBanner: React.FC<AIFeatureBannerProps> = ({ showAccountPrompt = false }) => (
  <>
    <Paper
      elevation={0}
      sx={{
        background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)',
        color: 'white',
        p: 4,
        borderRadius: 3,
        mb: 3,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: -20,
          right: -20,
          fontSize: 120,
          opacity: 0.1,
        }}
      >
        🤖
      </Box>
      <Stack spacing={3} sx={{ textAlign: 'center' }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: 'white', mb: 1 }}>
            Meet Terri - Your AI Assistant
          </Typography>
          <Typography variant="h6" sx={{ color: 'white', opacity: 0.95, mb: 2 }}>
            Get quotes from providers instantly with our AI agent
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'white',
              opacity: 0.9,
              fontSize: '1.1rem',
              fontWeight: 500,
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              px: 3,
              py: 2,
              borderRadius: 2,
              border: '1px solid rgba(255, 255, 255, 0.2)',
            }}
          >
            👇 Review the search results below and select one or more providers for Terri to call on
            your behalf
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: 3,
            mt: 2,
          }}
        >
          <Box sx={{ textAlign: 'left' }}>
            <Typography
              variant="body1"
              sx={{
                color: 'white',
                fontSize: '1rem',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                mb: 2,
              }}
            >
              <Box sx={{ fontSize: '1.2rem' }}>📞</Box>
              <Box>
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Free AI Calls:
                </Box>
                <br />
                Terri calls providers on your behalf
              </Box>
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: 'white',
                fontSize: '1rem',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
              }}
            >
              <Box sx={{ fontSize: '1.2rem' }}>📧</Box>
              <Box>
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Email Summaries:
                </Box>
                <br />
                Get detailed quotes and information via email
              </Box>
            </Typography>
          </Box>

          <Box sx={{ textAlign: 'left' }}>
            <Typography
              variant="body1"
              sx={{
                color: 'white',
                fontSize: '1rem',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
                mb: 2,
              }}
            >
              <Box sx={{ fontSize: '1.2rem' }}>🎧</Box>
              <Box>
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Call Recordings:
                </Box>
                <br />
                Listen to actual conversations anytime
              </Box>
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: 'white',
                fontSize: '1rem',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 2,
              }}
            >
              <Box sx={{ fontSize: '1.2rem' }}>💼</Box>
              <Box>
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Search History:
                </Box>
                <br />
                Access all your searches and calls in one place
              </Box>
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Paper>

    {false && showAccountPrompt && (
      <Alert
        severity="info"
        sx={{
          mb: 3,
          borderRadius: 2,
          fontSize: '1rem',
          '& .MuiAlert-message': {
            width: '100%',
          },
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
          <Typography sx={{ flex: 1 }}>
            <strong>Create a free account</strong> to have Terri call providers and get quotes on
            your behalf. No credit card required!
          </Typography>
          <Typography
            component="a"
            href={`${PublicRoutes.signup}?redirect=${encodeURIComponent(window.location.pathname)}`}
            sx={{
              backgroundColor: 'primary.main',
              color: 'white !important',
              px: 3,
              py: 1,
              borderRadius: 2,
              textDecoration: 'none',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            Create Account
          </Typography>
        </Stack>
      </Alert>
    )}
  </>
);

export default AIFeatureBanner;
